import axiosUrl from './axios.service';
import axios from 'axios';
import store from '../store/index';

const API_URL = axiosUrl.getAxiosUrl();

class OrganisationsService {
  getAllOrganisations() {
    return axios
      .get(API_URL + '/organisations/getAllOrganisations')
      .then((response) => {
        store.commit('organisations/updateOrganisations', response.data);
        /*  store.commit('grantItems/disableSearchPageLoading'); */
      });
    /*      .catch((error) => {
        if (error)
          store.commit('tree/updateModalError', error.response.data),
            store.commit('tree/enableModalError');
      }); */
  }
  
  getAllOrganisationsWithBasicInfo() {
    return axios
      .get(API_URL + '/organisations/getAllOrganisationsWithBasicInfo')
      .then((response) => {
        store.commit('organisations/updateOrganisationsWithBasicInfo', response.data);
      });
  }
}

export default new OrganisationsService();
